module.exports = [
  () => (text) => _.escape(text)
];
